import React, { useState, useContext } from "react";
import {
  SimpleGrid,
  Modal,
  Button,
  Title,
  Text,
} from "@mantine/core";
import { useHistory } from "react-router-dom";
import gql from "graphql-tag";
import { useMutation } from "@apollo/react-hooks";
import { AppContext, OPEN_TOAST } from "../Context";
import PaymentCountdown from "./paymentCountdown";
import _ from "lodash";
import moment from "moment";
import { useDidUpdate } from "@mantine/hooks";
import { ModalContext } from "../Context/ModalContext";
import { uriWithCulture } from "./util";
import { makeStyles } from "@material-ui/styles";

const PAY_BOOKING = gql`
  mutation initiatePayment {
    initiatePayment {
      uri
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  closeButton: {
    color: theme.app.labelColor,
  },
}));

const NewBookingModal = (props) => {
  const classes = useStyles();
  const { mybookings, language, culture } = props;
  const [opened, setOpened] = useState(false);
  const context = useContext(AppContext);
  const { openModal, setOpenModal } = useContext(ModalContext);
  const { dispatch } = context;
  const locale = culture.substring(0, 2).toLowerCase();

  const handleMutationSuccess = (data) => 
    (window.location = uriWithCulture(data.initiatePayment.uri, culture));


  const handleMutationError = (error) =>
    dispatch({ type: OPEN_TOAST, toastText: error, toastType: "error" });
  const [initiatePayment] = useMutation(PAY_BOOKING, {
    onError: handleMutationError,
    onCompleted: handleMutationSuccess,
  });

  let history = useHistory();
  const payableBookings =
    mybookings && mybookings.filter((b) => b.isConfirmed && !b.isPaid);
  const nextPayment = _.chain(payableBookings)
    .filter((x) => x.lastPaymentTime)
    .map((x) => moment(x.lastPaymentTime))
    .sort()
    .min()
    .value();

  useDidUpdate(() => {
    setOpened(openModal);
  }, [openModal]);

  return (
    <>
      {nextPayment ? (
        <Modal
          size="31.25rem"
          opened={opened}
          centered
          onClose={() => setOpenModal(false)}
          styles={{ header: { margin: 0 } }}
          padding="xl"
          radius="md"
          zIndex={1500}
          classNames={{ close: classes.closeButton }}
        >
          <SimpleGrid spacing="xl">
            <Title align="center" order={1} style={{ fontSize: "1.7rem" }}>
              {language.bookingSucceed}
            </Title>
            <SimpleGrid cols={1} spacing="xs">
              <Text align="center">{language.hasToPay}:</Text>
              <Text
                style={{ fontSize: "2rem", marginTop: "-0.5rem" }}
                align="center"
              >
                <PaymentCountdown
                  next={nextPayment}
                  locale={locale}
                  language={language}
                  isModal={true}
                />
              </Text>
            </SimpleGrid>
            <Text align="center">{language.payNowOrSeeBookings}</Text>
          </SimpleGrid>
          <SimpleGrid
            mt="xl"
            cols={2}
            spacing="sm"
            breakpoints={[{ maxWidth: 768, cols: 1, spacing: "sm" }]}
          >
            <Button
              color="violet.8"
              variant="outline"
              radius="sm"
              size="md"
              onClick={() => {
                setOpenModal(false);
                history.push("/bookings");
              }}
            >
              {language.showMyBookings}
            </Button>
            <Button
              color="violet.8"
              varianti="filled"
              radius="sm"
              size="md"
              onClick={initiatePayment}
            >
              {language.toPayment}
            </Button>
          </SimpleGrid>
        </Modal>
      ) : (
        ""
      )}
    </>
  );
};

export default NewBookingModal;
